import { isEqual } from 'lodash';
import { useCallback, useEffect } from 'react';
const useFromMenuUrlParams = ({ excludeKeys, parseOptions, }) => ({
    fromMenu: true,
    query: {},
    search: '',
    shouldUpdateFromMenu: () => false,
});
export const useTagsAndSort = ({ blockId, blockQuery, setBlockQuery, sortBy, }) => {
    var _a;
    const { query: updatedQuery, shouldUpdateFromMenu } = useFromMenuUrlParams({
        excludeKeys: [],
        parseOptions: { parseArrays: false },
    });
    const selectedTags = Object.values((_a = blockQuery === null || blockQuery === void 0 ? void 0 : blockQuery.tags) !== null && _a !== void 0 ? _a : {});
    const selectedSort = sortBy === null || sortBy === void 0 ? void 0 : sortBy.find((elem) => elem.value === (blockQuery === null || blockQuery === void 0 ? void 0 : blockQuery.sort));
    const handleChangeTags = useCallback((tags) => {
        setBlockQuery((prevBlockQuery) => (Object.assign(Object.assign({}, prevBlockQuery), { tags: Object.fromEntries(tags.map((tag) => [tag, tag])) })));
    }, [setBlockQuery]);
    const handleChangeSort = useCallback((sortSelected) => {
        setBlockQuery((prevBlockQuery) => (Object.assign(Object.assign({}, prevBlockQuery), { sort: sortSelected.value })));
    }, [setBlockQuery]);
    useEffect(() => {
        var _a, _b;
        if (shouldUpdateFromMenu()) {
            const newSelectedTags = Object.values((_b = (_a = updatedQuery === null || updatedQuery === void 0 ? void 0 : updatedQuery[blockId]) === null || _a === void 0 ? void 0 : _a.tags) !== null && _b !== void 0 ? _b : {});
            const newSelectedSort = sortBy === null || sortBy === void 0 ? void 0 : sortBy.find((elem) => { var _a; return elem.value === ((_a = updatedQuery === null || updatedQuery === void 0 ? void 0 : updatedQuery[blockId]) === null || _a === void 0 ? void 0 : _a.sort); });
            if (!isEqual(selectedSort, newSelectedSort)) {
                handleChangeSort(newSelectedSort);
            }
            if (!isEqual(selectedTags, newSelectedTags)) {
                handleChangeTags(newSelectedTags);
            }
        }
    }, [
        blockId,
        handleChangeSort,
        handleChangeTags,
        selectedSort,
        selectedTags,
        sortBy,
        updatedQuery,
    ]);
    return { selectedSort, selectedTags, handleChangeTags, handleChangeSort };
};
//# sourceMappingURL=useTagsAndSort.js.map